"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppwalletConnector = void 0;
const ws_connector_1 = require("./ws-connector");
const iconnector_1 = require("./iconnector");
const utils_1 = require("../utils");
const constants_1 = require("../protocol/constants");
const protocol_1 = require("../protocol");
class AppwalletConnector extends ws_connector_1.WsConnector {
    constructor() {
        super();
        this.walletName = 'OKX App';
        this.walletNameKey = 'walletModal.mobileConnectionModal.connectApp';
    }
    getTag() {
        return iconnector_1.OKX_APP_WALLET;
    }
    openWallet(engineConnectInfo, openAppLinkType) {
        var _a;
        let lineType = openAppLinkType !== null && openAppLinkType !== void 0 ? openAppLinkType : protocol_1.OpenAppLinkType.UniversalLink;
        if (engineConnectInfo && engineConnectInfo.connectRequest) {
            (0, utils_1.logDebug)(`appwallet-connector openwallet before useSHortLink engineConnectInfo.connectRequest JSON ${JSON.stringify(engineConnectInfo)}`);
            let localConnectRequest = engineConnectInfo.connectRequest;
            if (!(0, utils_1.useShortLink)()) {
                localConnectRequest = Object.assign(Object.assign({}, engineConnectInfo.connectRequest), { redirect: (_a = engineConnectInfo.redirect) !== null && _a !== void 0 ? _a : "none" });
            }
            let { universalLink, deepLink } = (0, utils_1.getOKXLink)(localConnectRequest);
            (0, utils_1.openOKXDeeplinkWithFallback)(deepLink, universalLink, lineType);
        }
        else {
            if ((0, utils_1.isOS)('android')) {
                (0, utils_1.openDeeplinkWithFallback)(constants_1.stackDeepLink, () => { });
            }
            else {
                (0, utils_1.openOKXDeeplinkWithFallback)(constants_1.standardDeeplink, constants_1.shortUniversalLink, lineType);
            }
        }
    }
}
exports.AppwalletConnector = AppwalletConnector;
